module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/9mill-active-f02a0480b066aef15400193439ebeba9.png";